module.exports = __webpack_public_path__ + "static/media/Icon_menu_guidebook.1bd5f386.svg";